/* PetBiome Gut Microbiome Test Kit - Black Friday lander.
 *
 * Two things make this different from the product page it is built from.
 *
 * 1. The price shown is BELOW the product's list price, because it comes from
 *    a discount code rather than the variant. So the figure is not read from
 *    the variant here - it comes from the section settings, alongside the code
 *    that produces it. Set them together or not at all.
 *
 * 2. The add therefore has two steps: the line goes in with its pet-detail
 *    properties through /cart/add.js, then the browser is sent through
 *    /discount/CODE to apply the code. A cart permalink would apply the code
 *    in one step but cannot carry line-item properties, which is exactly why
 *    orders from the £120 lander reach the lab with no pet details.
 *
 * Config arrives as window.B4P_BF from the section.
 */
(function () {
  var CFG = window.B4P_BF || {};
  var root = document.getElementById('b4pPdpRoot');
  if (!root || root.dataset.b4pBound) { return; }
  root.dataset.b4pBound = '1';

  var VARIANTS = CFG.variants || [];
  var sel = { loc: 'uk', tt: 'first' };

  var petField = document.getElementById('b4pPet');
  var healthField = document.getElementById('b4pHealth');
  var petWrap = document.getElementById('b4pPetFields');
  var petErr = document.getElementById('b4pPetErr');
  var mainBtn = document.getElementById('b4pPdpMain');
  var soldOut = document.getElementById('b4pSoldOut');
  var addErr = document.getElementById('b4pNoVariant');

  function hide(el) { if (el) { el.hidden = true; } }
  function show(el) { if (el) { el.hidden = false; } }

  function resolve() {
    var wantLoc = sel.loc === 'uk' ? /^united\s*kin/i : /^international/i;
    var wantTT = sel.tt === 'first' ? 'first test' : 'retest';
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      if (!wantLoc.test(String(v.o1 || ''))) { continue; }
      if (String(v.o2 || '').toLowerCase() !== wantTT) { continue; }
      return v;
    }
    return null;
  }

  function applyVariant() {
    var v = resolve();
    if (!v) {
      if (mainBtn) { mainBtn.disabled = true; }
      show(addErr);
      return;
    }
    hide(addErr);
    if (mainBtn) {
      mainBtn.textContent = (v.available ? 'Add to Cart · ' : 'Sold out · ') + CFG.bfPriceStr;
      mainBtn.disabled = !v.available;
    }
    if (v.available) { hide(soldOut); } else { show(soldOut); }
  }

  function selectVariant(el, g) {
    root.querySelectorAll('.pet-card[data-g="' + g + '"]').forEach(function (p) {
      p.classList.remove('selected');
      p.setAttribute('aria-pressed', 'false');
    });
    el.classList.add('selected');
    el.setAttribute('aria-pressed', 'true');
    var val = el.getAttribute('data-val');
    if (val) { sel[g] = val; }
    applyVariant();
  }

  root.querySelectorAll('.pet-card[data-g]').forEach(function (el) {
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-pressed', el.classList.contains('selected') ? 'true' : 'false');
    el.addEventListener('click', function () { selectVariant(el, el.getAttribute('data-g')); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectVariant(el, el.getAttribute('data-g')); }
    });
  });

  root.querySelectorAll('.pet-card:not([data-g])').forEach(function (el) {
    el.addEventListener('click', function () {
      root.querySelectorAll('.pet-card:not([data-g])').forEach(function (p) { p.classList.remove('selected'); });
      el.classList.add('selected');
    });
  });

  var mainImg = document.getElementById('mainImg');
  root.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var full = t.getAttribute('data-full');
      if (!full || !mainImg) { return; }
      mainImg.src = full;
      root.querySelectorAll('.thumb').forEach(function (o) { o.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  function attrs() {
    var a = { 'Landing Page': CFG.source || 'bf-lander' };
    try {
      var q = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid']
        .forEach(function (k) { var v = q.get(k); if (v) { a[k] = v; } });
    } catch (e) {}
    return a;
  }

  var busy = false;
  function addToCart() {
    if (busy) { return; }
    var v = resolve();
    var pet = petField ? petField.value.trim() : '';

    if (petField && pet.length < 3) {
      if (petWrap) { petWrap.classList.add('is-invalid'); }
      show(petErr);
      petField.focus();
      return;
    }
    if (petWrap) { petWrap.classList.remove('is-invalid'); }
    hide(petErr);
    if (!v || !v.available) { return; }

    busy = true;
    hide(addErr);
    mainBtn.setAttribute('aria-busy', 'true');

    var props = {};
    props[CFG.petProperty || 'Pet Name, Age, Breed, and Diet Details'] = pet;
    var health = healthField ? healthField.value.trim() : '';
    if (health) { props[CFG.healthProperty || 'Health Information if Relevant'] = health; }

    var H = { 'Content-Type': 'application/json' };
    fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ attributes: attrs() }) })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: H,
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
        });
      })
      .then(function (r) {
        if (!r || !r.ok) { throw new Error('add failed'); }
        /* The code is applied on the way to the cart, so the price the page
           promised is the price they see before they ever reach checkout. */
        var code = CFG.discountCode;
        window.location = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart'
          : '/cart';
      })
      .catch(function () {
        busy = false;
        mainBtn.removeAttribute('aria-busy');
        show(addErr);
      });
  }

  if (mainBtn) { mainBtn.addEventListener('click', addToCart); }

  /* ---- Countdown ------------------------------------------------------
     Driven by the section's end date. If it is missing or already past, the
     whole urgency band goes rather than showing a dead or negative clock. */
  var band = document.getElementById('b4pUrgency');
  var clock = document.getElementById('b4pCountdown');
  if (band && clock) {
    var endRaw = band.getAttribute('data-end') || '';
    var end = endRaw ? new Date(endRaw).getTime() : NaN;
    if (!endRaw || isNaN(end)) {
      clock.hidden = true;
    } else {
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) { band.hidden = true; return; }
        var d = Math.floor(left / 86400000);
        var h = Math.floor(left / 3600000) % 24;
        var m = Math.floor(left / 60000) % 60;
        var s = Math.floor(left / 1000) % 60;
        clock.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm ' + s + 's';
        clock.hidden = false;
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  var pqEl = document.getElementById('promoQuote');
  var quotes = CFG.quotes || [];
  if (pqEl && quotes.length > 1) {
    var i = 0;
    setInterval(function () {
      pqEl.classList.add('fade');
      setTimeout(function () {
        i = (i + 1) % quotes.length;
        pqEl.textContent = quotes[i];
        pqEl.classList.remove('fade');
      }, 400);
    }, 4200);
  }

  applyVariant();
})();